<div
  class="chat-bubble"
  [ngClass]="{
    user: isUser,
    assistant: isAssistant,
    error: isError
  }"
>
  {{ messageText }}

  <div *ngIf="templates.length > 0" class="templates-row" style="display: flex; flex-direction: row; gap: 16px; margin-top: 12px;">
    <hr><br>

    <div *ngFor="let template of templates" class="template-item" style="display: flex; flex-direction: column; align-items: center; max-width: 120px;">
      <img [src]="template.imageUrl || template.catalogImageUrl" alt="{{ template.name }}" style="width: 80px; height: 80px; object-fit: cover; border-radius: 8px; margin-bottom: 8px;" />
      <span style="text-align: center; font-size: 14px;">{{ template.name }}</span>
    </div>
  </div>

  <div *ngIf="presentations.length > 0">
    <hr><br>

    <div *ngFor="let presentation of presentations" class="presentation-item">
      <div style="text-align: left; font-size: 14px;">{{ presentation.name }}</div>
    </div>
  </div>
</div>
